var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-3 py-1 text-sm border-t flex"},[_c('div',[_vm._v("Tinkerwell: "+_vm._s(_vm.loadTime ? ("Loaded in " + _vm.loadTime + "s") : 'Loading'))])])}
var staticRenderFns = []

export { render, staticRenderFns }